<template>
  <div
    class="card mb-4 cursor-pointer"
    data-testid="rg-history-card"
    @click="expanded = !expanded"
  >
    <div class="flex flex-row items-center p-2 sm:p-3 gap-2 min-w-0">
      <div class="flex flex-col flex-1 min-w-0">
        <div class="flex flex-col min-w-0">
          <h3 class="text-base sm:text-lg truncate">{{ dimensionName }}</h3>
          <span class="text-sm sm:text-md text-[var(--color-disabled)]">{{ formattedDate }}</span>
        </div>
      </div>
      <div class="flex items-center flex-shrink-0">
        <font-awesome-icon
          v-if="expanded"
          icon="fa-solid fa-chevron-up"
          class="text-gray-400 hover:text-gray-600 transition-colors"
        />
        <font-awesome-icon
          v-else
          icon="fa-solid fa-chevron-down"
          class="text-gray-400 hover:text-gray-600 transition-colors"
        />
      </div>
    </div>
    <div v-show="expanded" class="flex flex-col border-t pt-4">
      <div class="my-0 mx-2 sm:mx-4 overflow-x-hidden">
        <div>
          <div class="mt-4 sm:mt-6">
            <label class="mb-2">
              <h4 class="font-bold text-base sm:text-lg">{{ $t('ReflexionGuideline.yourResponse') }}</h4></label>
          </div>
          <template v-if="assessment.textFieldQuestion.length > 0">
            <ReflexionGuidelineTextFieldResponse
              v-for="(question, index) in assessment.textFieldQuestion"
              :key="index"
              :question="question">
            </ReflexionGuidelineTextFieldResponse>
          </template>
        </div>
        </div>
        <div class="mt-4 sm:mt-6">
          <label class="text-base sm:text-lg mb-1">
              <b>{{ comparisonHeader }}</b></label>
        </div>
        <label class="block text-sm sm:text-base break-words">{{ rangeSliderQuestion }}</label>
        <div class="flex flex-row justify-center items-center m-2 sm:m-4 flex-wrap gap-2 sm:gap-0 max-sm:flex-col max-sm:my-4 max-sm:mx-0">
          <div class="flex flex-row items-center justify-end max-sm:w-full max-sm:flex-row max-sm:justify-between max-sm:mb-2"
              :class="isReflectedInDe">
            <label class="text-sm sm:text-base">{{ $t('ReflexionGuideline.weekResult') }}</label>
            <label class="flex h-6 w-16 rounded-2xl my-0 mx-2 sm:mx-4 justify-center shrink-0
             bg-[var(--color-disabled)]">{{ assessment.rangeSliderQuestion.answer }}</label>
          </div>
          <div class="flex flex-row items-center justify-start max-sm:w-full max-sm:flex-row-reverse max-sm:justify-between"
              :class="isMindsetInDe">
            <label class="flex h-6 w-16 rounded-2xl my-0 mx-2 sm:mx-4 justify-center shrink-0
              bg-[var(--color-orange)]">
              {{ assessment.mindsetResult }}</label>
            <label class="text-sm sm:text-base">{{ selfComparisonText }}</label>
          </div>
        </div>
        <div class="flex flex-col mt-4 sm:mt-6 rounded-lg p-3 mb-4 sm:mb-5 bg-[var(--color-answer-card)]">
          <div class="flex flex-row items-center justify-start mb-2 sm:mb-3 flex-wrap gap-2">
            <font-awesome-icon class="h-6 sm:h-8 shrink-0" icon="fa-regular fa-lightbulb"/>
            <label class="text-base sm:text-lg font-bold">{{ $t('ReflexionGuideline.quickTip') }}</label>
          </div>
          <div class="min-w-0">
            <label class="block text-sm sm:text-base break-words">{{ tip }}</label>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import ReflexionGuidelineTextFieldResponse from '@/components/Home/ReflexionGuidelineComponent/ReflexionGuidelineTextFieldResponse.vue';

export default {
  name: 'ReflexionGuidelineResponseComponent',
  props: ['assessment'],
  components: { ReflexionGuidelineTextFieldResponse },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    formattedDate() {
      const date = new Date(this.assessment.date_assessmentMade);
      return `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
    },
    tip() {
      if (this.$i18n.locale === 'de') {
        return this.assessment.tip.de;
      }
      return this.assessment.tip.en;
    },
    rangeSliderQuestion() {
      if (this.$i18n.locale === 'de') {
        return this.assessment.rangeSliderQuestion.question_de;
      }
      return this.assessment.rangeSliderQuestion.question_en;
    },
    dimensionName() {
      if (this.$i18n.locale === 'de') {
        return this.assessment.dimensionName.de;
      }
      return this.assessment.dimensionName.en;
    },
    isReflectedInDe() {
      if (this.$i18n.locale === 'de') {
        return 'w-[57%]';
      }
      return 'w-1/2';
    },
    isMindsetInDe() {
      if (this.$i18n.locale === 'de') {
        return 'w-[43%]';
      }
      return 'w-[50%]';
    },
    comparisonHeader() {
      if (this.assessment.isMindset) {
        return this.$t('ReflexionGuideline.mindsetComparison');
      }
      return this.$t('ReflexionGuideline.otherAssessmentComparison');
    },
    selfComparisonText() {
      if (this.assessment.isMindset) {
        return this.$t('ReflexionGuideline.currentMindset');
      }
      return this.$t('ReflexionGuideline.currentOtherAssessment');
    },
  },
};
</script>
